import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { sify } from 'chinese-conv'
import _ from 'lodash'

import AddIcon from '@mui/icons-material/Add'
import ClearIcon from '@mui/icons-material/Clear'
import CachedIcon from '@mui/icons-material/Cached'
import { Box, Stack, Typography } from '@mui/material'
import { constants as cons, TABLE_TYPE_DEFAULT_VALUE, IMAGE_TYPE, PICTURE_SIZE, UPLOAD_TYPE } from '../../Constants/constants'
import { setQueueTemplate, setQueueTemplateTimeSectionValue, setQueueTemplateTableTypeValue } from '../../actions/queueTemplateAction'
import { EditCreateDisplay } from '../../Component/EditCreateDisplay/EditCreateDisplay'
import { TempTextInput } from '../../Component/Input/TempTextInput'
import { TempAutoSelectInput } from '../../Component/Input/TempAutoSelectInput'
import { TempBtn } from '../../Component/Input/TempBtn'
import { TempCustomCheckBox } from '../../Component/Custom/TempCustomCheckBox'
import QueueTemplateValidation from '../../validations/queueTemplateValidation'
import { queueTemplateValidationConstants } from '../../Constants/validationConstants'
import { GlobalDialog } from '../../Component/GlobalDialog'
import { Clear } from '@mui/icons-material'
import MUICollapse from '../../Component/common/collapse/MUICollapse'
import { UploadImage } from '../../Component/UploadImage/UploadImage'
import { UploadImageV2 } from '../../Component/UploadImage/UploadImageV2'

import '../../styles/queueTemplate.scss'

export const QueueTemplateTimeSection = ({ setCustomIdNumber, customIdNumber }) => {
  const dispatch = useDispatch()
  const savedQueueTemplate = useSelector((state) => state.queueTemplate.ui.queueTemplate)
  const savedTimeSection = useSelector((state) => state.queueTemplate.ui.timeSection)
  const [timeSectionInputList, setTimeSectionInputList] = useState(_.cloneDeep(savedTimeSection))

  // eslint-disable-next-line no-unused-vars
  const [errorVersion, setErrorVersion] = useState(QueueTemplateValidation.getVersion())

  const [dialog, setDialog] = useState({
    open: false,
    dialogActions: [],
  })

  const resource = 'TimeSection'

  const generateTimeSectionDescription = () => {
    let label = ''

    label += savedTimeSection.startTime.substring(0, 5) + ' - '

    if (savedTimeSection.endTime && savedTimeSection.endTime.substring(3, 5) === '59' && savedTimeSection.endTime.substring(6, 8) === '59') {
      label += Number(savedTimeSection.endTime.substring(0, 2)) + 1 + ':00'
    } else if (savedTimeSection.endTime && savedTimeSection.endTime.substring(6, 8) === '59') {
      let endTime = Number(savedTimeSection.endTime.substring(3, 5)) + 1

      if (endTime < 10) {
        endTime = '0' + endTime
      }

      label += savedTimeSection.endTime.substring(0, 2) + ':' + endTime
    } else {
      label += savedTimeSection.endTime.substring(0, 5)
    }

    onChangeInput('description', label)
  }

  const contents = [
    {
      tab: (
        <>
          <TempAutoSelectInput
            inputSetting={{
              label: { resource: resource, key: 'timeSectionId' },
              value: savedTimeSection.timeSectionId,
              selectValue: cons.CHOICES.QUEUE_TEMPLATE.TIME_SECTION_ID,
              name: 'timeSectionId',
              freeSolo: true,
              disableStatusThemeColor: true,
              helperTextIcon: true,
              helperText: QueueTemplateValidation.getErrorMessages(
                queueTemplateValidationConstants.KEY_TIME_SECTION_ID,
                savedTimeSection.customId
              ).map((error) => {
                return error
              }),
            }}
            handleChange={onChangeInput}
          />
          {savedTimeSection.id && (
            <TempAutoSelectInput
              inputSetting={{
                label: { resource: resource, key: 'status' },
                value: savedTimeSection.status,
                selectValue: cons.CHOICES.QUEUE_TEMPLATE.STATUS,
                name: 'status',
                disableClearable: true,
                helperTextIcon: true,
                helperText: QueueTemplateValidation.getErrorMessages(
                  queueTemplateValidationConstants.KEY_TIME_SECTION_STATUS,
                  savedTimeSection.customId
                ).map((error) => {
                  return error
                }),
              }}
              handleChange={onChangeInput}
            />
          )}
          <TempCustomCheckBox
            className="customize-btn"
            value={savedTimeSection.disableLabel}
            customName={{ resource: resource, key: 'isAutoTranslateTimeSectionLabel' }}
            onSelectCheckbox={onSelectCheckbox}
          />
          <TempTextInput
            inputSetting={{
              label: { resource: resource, key: 'timeSectionEnLabel' },
              value: savedTimeSection?.label?.en,
              name: 'label.en',
              multiline: true,
              helperTextIcon: true,
              helperText: QueueTemplateValidation.getErrorMessages(
                queueTemplateValidationConstants.KEY_TIME_SECTION_EN_LABEL,
                savedTimeSection.customId
              ).map((error) => {
                return error
              }),
            }}
            handleChange={onChangeInput}
          />
          <TempTextInput
            inputSetting={{
              label: { resource: resource, key: 'timeSectionTcLabel' },
              value: savedTimeSection?.label?.['zh-HK'],
              name: 'label.zh-HK',
              translateName: savedTimeSection.disableLabel ? ['label.zh-CN'] : null,
              inputList: timeSectionInputList,
              setInputList: setTimeSectionInputList,
              multiline: true,
              helperTextIcon: true,
              helperText: QueueTemplateValidation.getErrorMessages(
                queueTemplateValidationConstants.KEY_TIME_SECTION_TC_LABEL,
                savedTimeSection.customId
              ).map((error) => {
                return error
              }),
            }}
            handleChange={onChangeInput}
          />
          <TempTextInput
            inputSetting={{
              label: { resource: resource, key: 'timeSectionScLabel' },
              value: savedTimeSection?.label?.['zh-CN'],
              name: 'label.zh-CN',
              inputList: timeSectionInputList,
              setInputList: setTimeSectionInputList,
              disabled: savedTimeSection.disableLabel,
              multiline: true,
              helperTextIcon: true,
              helperText: QueueTemplateValidation.getErrorMessages(
                queueTemplateValidationConstants.KEY_TIME_SECTION_SC_LABEL,
                savedTimeSection.customId
              ).map((error) => {
                return error
              }),
            }}
            handleChange={onChangeInput}
          />
          <TempCustomCheckBox
              className="customize-btn"
              value={savedTimeSection.isSyncSessionDateWithAllTableTypes}
              customName={{ resource: resource, key: 'isSyncSessionDateWithAllTableTypes' }}
              onSelectCheckbox={onSelectCheckbox}
            />
            <TempTextInput
              inputSetting={{
                label: { resource: resource, key: 'sessionDate' },
                value: savedTimeSection.sessionDate,
                name: 'sessionDate',
                disabledStyle: true,
                disabled: !savedTimeSection.isSyncSessionDateWithAllTableTypes,
                type: cons.TYPE.DATE,
              }}
              handleChange={onChangeInput}
            />
          <TempCustomCheckBox
            className="customize-btn"
            value={savedTimeSection.isSyncTimeFieldsWithAllTableTypes}
            customName={{ resource: resource, key: 'isSyncTimeFieldsWithAllTableTypes' }}
            onSelectCheckbox={onSelectCheckbox}
          />
          <TempTextInput
            inputSetting={{
              label: { resource: resource, key: 'startTime' },
              value: savedTimeSection.startTime,
              name: 'startTime',
              step: '2',
              disabled: !savedTimeSection.isSyncTimeFieldsWithAllTableTypes,
              helperText: QueueTemplateValidation.getErrorMessages(
                queueTemplateValidationConstants.KEY_TIME_SECTION_START_TIME,
                savedTimeSection.customId
              ).map((error) => {
                return error
              }),
              type: cons.TYPE.TIME,
            }}
            handleChange={onChangeInput}
          />
          <TempTextInput
            inputSetting={{
              label: { resource: resource, key: 'endTime' },
              value: savedTimeSection.endTime,
              name: 'endTime',
              step: '2',
              disabled: !savedTimeSection.isSyncTimeFieldsWithAllTableTypes,
              helperText: QueueTemplateValidation.getErrorMessages(
                queueTemplateValidationConstants.KEY_TIME_SECTION_END_TIME,
                savedTimeSection.customId
              ).map((error) => {
                return error
              }),
              type: cons.TYPE.TIME,
            }}
            handleChange={onChangeInput}
          />
          <TempTextInput
            inputSetting={{
              label: { resource: resource, key: 'timeSectionDescription' },
              value: savedTimeSection?.description,
              name: 'description',
              disabled: !savedTimeSection.isSyncTimeFieldsWithAllTableTypes,
              onClickEndAdornmentIconButton: () => generateTimeSectionDescription(),
              endAdornmentIconButton: <CachedIcon />,
              disabledEndAdornmentIconButton: !!(!savedTimeSection.startTime || !savedTimeSection.endTime),
              disabledOnClickInputField: true,
              disabledStyle: true,
              multiline: true,
              clear: true,
            }}
            handleChange={onChangeInput}
          />
          <MUICollapse title="ICON ASSET">
              <div className="image">
                <UploadImageV2
                  // type={IMAGE_TYPE.RESTAURANT_IMAGE}
                  title={{ resource: resource, key: 'timeSectionMobileIcon' }}
                  name="mobileIcon"
                  saveImage={handleSaveImage}
                  picture={savedTimeSection?.mobileIcon}
                  uploadType={UPLOAD_TYPE.FORMDATA}
                  uploadImagePath={cons.PATH.SHOP.UPLOAD_RESTAURANT_MEDIA}
                  size={PICTURE_SIZE.MID}
                  allowedFileExtensionList={['image/jpeg', 'image/jpg']}
                  removeImage={() => onChangeInput('mobileIcon', null)}
                  showApplyToAll={true}
                />
              </div>
              <div className="image">
                <UploadImageV2
                  // type={IMAGE_TYPE.RESTAURANT_IMAGE}
                  title={{ resource: resource, key: 'timeSectionKioskIcon' }}
                  name="kioskIcon"
                  saveImage={handleSaveImage}
                  picture={savedTimeSection?.kioskIcon}
                  uploadType={UPLOAD_TYPE.FORMDATA}
                  uploadImagePath={cons.PATH.SHOP.UPLOAD_RESTAURANT_MEDIA}
                  size={PICTURE_SIZE.MID}
                  allowedFileExtensionList={['image/jpeg', 'image/jpg']}
                  removeImage={() => onChangeInput('kioskIcon', null)}
                  showApplyToAll={true}
                />
              </div>
          </MUICollapse>
        </>
      ),
      btn: false,
    },
  ]

  function onSelectCheckbox(e, name) {
    const clonedSavedQueueTemplate = _.cloneDeep(savedQueueTemplate)
    const clonedSavedTimeSection = _.cloneDeep(savedTimeSection)
    switch (name.key) {
      case 'isAutoTranslateTimeSectionLabel':
        clonedSavedTimeSection.disableLabel = e

        if (e) {
          clonedSavedTimeSection.label['zh-CN'] = clonedSavedTimeSection?.label?.['zh-HK']
            ? sify(clonedSavedTimeSection?.label?.['zh-HK'])
            : clonedSavedTimeSection?.label?.['zh-HK']
        }

        break
      case 'isSyncSessionDateWithAllTableTypes':
        clonedSavedTimeSection.isSyncSessionDateWithAllTableTypes = e
        if (!e) {
          clonedSavedTimeSection.sessionDate = null
        } else {
          for (const tableType of clonedSavedTimeSection.tableTypeList) {
            tableType.sessionDate = clonedSavedTimeSection.sessionDate
          }
        }
        break
      case 'isSyncTimeFieldsWithAllTableTypes':
        clonedSavedTimeSection.isSyncTimeFieldsWithAllTableTypes = e
        if (!e) {
          clonedSavedTimeSection.startTime = null
          clonedSavedTimeSection.endTime = null
          clonedSavedTimeSection.description = ''
        } else {
          for (const tableType of clonedSavedTimeSection.tableTypeList) {
            tableType.startTime = clonedSavedTimeSection.startTime
            tableType.endTime = clonedSavedTimeSection.endTime
            tableType.description = clonedSavedTimeSection?.description
          }
        }
        break
      case 'isSyncRequestTicketTimeFieldsWithAllTableTypes':
        clonedSavedTimeSection.isSyncRequestTicketTimeFieldsWithAllTableTypes = e
        if (!e) {
          clonedSavedTimeSection.kioskRequestTicketStartTime = null
          clonedSavedTimeSection.kioskRequestTicketEndTime = null
          clonedSavedTimeSection.mobileRequestTicketStartTime = null
          clonedSavedTimeSection.mobileRequestTicketEndTime = null
        } else {
          for (const tableType of clonedSavedTimeSection.tableTypeList) {
            tableType.kioskRequestTicketStartTime = clonedSavedTimeSection.kioskRequestTicketStartTime
            tableType.kioskRequestTicketEndTime = clonedSavedTimeSection.kioskRequestTicketEndTime
            tableType.mobileRequestTicketStartTime = clonedSavedTimeSection.mobileRequestTicketStartTime
            tableType.mobileRequestTicketEndTime = clonedSavedTimeSection.mobileRequestTicketEndTime
          }
        }
        break
      default:
    }
    let newTimeSectionIdx = clonedSavedQueueTemplate.findIndex((timeSection) => savedTimeSection.customId === timeSection.customId)
    if (newTimeSectionIdx >= 0) {
      clonedSavedQueueTemplate[newTimeSectionIdx] = clonedSavedTimeSection
    } else {
      clonedSavedTimeSection.customId = 'section_' + customIdNumber
      setCustomIdNumber(customIdNumber + 1)
      clonedSavedQueueTemplate.push(clonedSavedTimeSection)
    }
    dispatch(setQueueTemplateTimeSectionValue(clonedSavedTimeSection))
    dispatch(setQueueTemplate(clonedSavedQueueTemplate))

    const newTableTypeInput = _.cloneDeep(TABLE_TYPE_DEFAULT_VALUE)
    dispatch(setQueueTemplateTableTypeValue(newTableTypeInput))

    QueueTemplateValidation.validateTemplateTimeSection(clonedSavedQueueTemplate)
    setErrorVersion(QueueTemplateValidation.getVersion())
  }

  function onChangeTimeSectionStatus(value) {
    const newSavedQueueTemplate = _.cloneDeep(savedQueueTemplate)
    const newSavedTimeSection = _.cloneDeep(savedTimeSection)
    newSavedTimeSection['status'] = value
    newSavedTimeSection.tableTypeList = newSavedTimeSection.tableTypeList.filter((tableType) => {
      if (tableType.id) {
        tableType.status = 'D'
      }
      return tableType.id
    })
    let newTimeSectionIdx = newSavedQueueTemplate.findIndex((queueTemplate) => savedTimeSection.customId === queueTemplate.customId)
    if (newTimeSectionIdx >= 0) {
      newSavedQueueTemplate[newTimeSectionIdx] = newSavedTimeSection
    } else {
      newSavedTimeSection.customId = 'section_' + customIdNumber
      setCustomIdNumber(customIdNumber + 1)
      newSavedQueueTemplate.push(newSavedTimeSection)
    }
    dispatch(setQueueTemplateTimeSectionValue(newSavedTimeSection))
    dispatch(setQueueTemplate(newSavedQueueTemplate))

    const newTableTypeInput = _.cloneDeep(TABLE_TYPE_DEFAULT_VALUE)
    dispatch(setQueueTemplateTableTypeValue(newTableTypeInput))

    QueueTemplateValidation.validateTemplateTimeSection(newSavedQueueTemplate)
    setErrorVersion(QueueTemplateValidation.getVersion())
    onCloseTimeSectionStatusDialog()
  }

  function onCloseTimeSectionStatusDialog() {
    setDialog({
      open: false,
      dialogActions: [],
    })
  }

  function onCloseDialog() {
    setDialog({
      open: false,
      dialogActions: [],
    })
  }

  function handleSaveImage(name, image, index, applyToAll) {
      const newQueueTemplate = _.cloneDeep(savedQueueTemplate)
      const newTimeSection = _.cloneDeep(savedTimeSection);
  
      if(applyToAll){
        newTimeSection.mobileIcon = image;
        newTimeSection.kioskIcon = image;
      } else {
        newTimeSection[`${name}`] = image;
      }

      for (const tableType of newTimeSection.tableTypeList) {
        tableType.mobileIcon = newTimeSection?.mobileIcon
        tableType.kioskIcon = newTimeSection?.kioskIcon
      }

      let newTimeSectionIdx = newQueueTemplate.findIndex((timeSection) => savedTimeSection.customId === timeSection.customId)
      if (newTimeSectionIdx >= 0) {
        newQueueTemplate[newTimeSectionIdx] = newTimeSection
      } else {
        newTimeSection.customId = 'section_' + customIdNumber
        setCustomIdNumber(customIdNumber + 1)
        newQueueTemplate.push(newTimeSection)
      }

      dispatch(setQueueTemplateTimeSectionValue(newTimeSection))
      dispatch(setQueueTemplate(newQueueTemplate))
    }

  function onChangeInput(name, e) {
    const newSavedQueueTemplate = _.cloneDeep(savedQueueTemplate)
    const newSavedTimeSection = _.cloneDeep(savedTimeSection)

    // helper to set nested path or plain key
    const setField = (path, val) => {
      if (String(path).includes('.')) {
        _.set(newSavedTimeSection, path, val)
      } else {
        newSavedTimeSection[path] = val
      }
    }

    const maybeAutoTranslate = (path, val) => {
      const tcMatch = path.match(/\.(zh-HK|zh-TW)$/)
      if (!tcMatch) return
      const scPath = path.replace(/\.(zh-HK|zh-TW)$/, '.zh-CN')
      if (newSavedTimeSection.disableLabel) {
        _.set(newSavedTimeSection, scPath, val ? sify(val) : null)
      }
    }

    switch (name) {
      case 'label.zh-HK':
        if (savedTimeSection.disableLabel === true) {
          setField(name, e)
          setField('label.zh-CN', sify(e))
        } else {
          setField(name, e)
        }
        break
      case 'status':
        if (e === 'D') {
          setDialog({
            open: true,
            onClose: onCloseDialog,
            dialogContent:
              'After Time Section saves, all the Table Type Status will change to D (Deactive) and new created Table Type will be deleted. Please press Yes if you confirm!',
            dialogActions: [
              { label: { key: 'yes' }, onClick: () => onChangeTimeSectionStatus(e), icon: <SaveIcon /> },
              { label: { key: 'no' }, onClick: () => onCloseDialog(), icon: <ClearIcon /> },
            ],
          })
        } else {
          setField(name, e)
          newSavedTimeSection.tableTypeList.map((tableType) => {
            tableType.status = 'A'
            return tableType
          })
        }
        break
      case 'sessionDate':
        setField(name, e || null)
        if (newSavedTimeSection.isSyncSessionDateWithAllTableTypes) {
          for (const tableType of newSavedTimeSection.tableTypeList) {
            tableType.sessionDate = newSavedTimeSection.sessionDate
          }
        }
        break
      case 'endTime':
      case 'startTime':
      case 'description':
        setField(name, e)
        if (newSavedTimeSection.isSyncTimeFieldsWithAllTableTypes) {
          for (const tableType of newSavedTimeSection.tableTypeList) {
            tableType.startTime = newSavedTimeSection.startTime
            tableType.endTime = newSavedTimeSection.endTime
            tableType.description = newSavedTimeSection?.description
          }
        }
        break
      case 'kioskRequestTicketStartTime':
      case 'kioskRequestTicketEndTime':
      case 'mobileRequestTicketStartTime':
      case 'mobileRequestTicketEndTime':
        setField(name, e)
        if (newSavedTimeSection.isSyncRequestTicketTimeFieldsWithAllTableTypes) {
          for (const tableType of newSavedTimeSection.tableTypeList) {
            tableType.kioskRequestTicketStartTime = newSavedTimeSection.kioskRequestTicketStartTime
            tableType.kioskRequestTicketEndTime = newSavedTimeSection.kioskRequestTicketEndTime
            tableType.mobileRequestTicketStartTime = newSavedTimeSection.mobileRequestTicketStartTime
            tableType.mobileRequestTicketEndTime = newSavedTimeSection.mobileRequestTicketEndTime
          }
        }
        break
      default:
        setField(name, e)
    }

    let newTimeSectionIdx = newSavedQueueTemplate.findIndex((timeSection) => savedTimeSection.customId === timeSection.customId)
    if (newTimeSectionIdx >= 0) {
      newSavedQueueTemplate[newTimeSectionIdx] = newSavedTimeSection
    } else {
      newSavedTimeSection.customId = 'section_' + customIdNumber
      setCustomIdNumber(customIdNumber + 1)
      newSavedQueueTemplate.push(newSavedTimeSection)
    }
    dispatch(setQueueTemplateTimeSectionValue(newSavedTimeSection))
    dispatch(setQueueTemplate(newSavedQueueTemplate))

    const newTableTypeInput = _.cloneDeep(TABLE_TYPE_DEFAULT_VALUE)
    dispatch(setQueueTemplateTableTypeValue(newTableTypeInput))

    QueueTemplateValidation.validateTemplateTimeSection(newSavedQueueTemplate)
    setErrorVersion(QueueTemplateValidation.getVersion())
  }

  // useEffect(() => {
  //   console.log('savedTimeSection', savedTimeSection)
  // }, [savedTimeSection])

  return (
    <div className="sub-tab-wrapper-margin-32">
      <EditCreateDisplay
        code={savedTimeSection && savedTimeSection.customId ? savedTimeSection.customId : ''}
        resource={resource}
        tabs={false}
        content={contents}
        onChangeInput={onChangeInput}
        display={savedTimeSection.customId ? 'edit' : 'create'}
      />
      {dialog && dialog.open && <GlobalDialog dialogInfo={dialog} />}
    </div>
  )
}
